import React from "react";

function Complete(props: any) {
  return (
      <svg width="94" height="94" viewBox="0 0 94 94" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="7" y="7" width="80" height="80" rx="40" fill="#D1FADF"/>
      <rect x="7" y="7" width="80" height="80" rx="40" stroke="#ECFDF3" stroke-width="13.3333"/>
      <path d="M63.6666 45.4666V46.9999C63.6645 50.594 62.5008 54.0911 60.3488 56.9696C58.1969 59.8482 55.1721 61.9541 51.7255 62.9731C48.279 63.9921 44.5954 63.8698 41.224 62.6242C37.8527 61.3787 34.9743 59.0768 33.0182 56.0617C31.062 53.0467 30.1329 49.48 30.3694 45.8938C30.6059 42.3075 31.9953 38.8938 34.3304 36.1617C36.6655 33.4296 39.8212 31.5256 43.3269 30.7335C46.8326 29.9415 50.5004 30.3038 53.7833 31.7666M63.6666 33.6666L46.9999 50.3499L41.9999 45.3499" stroke="#039855" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

  );
}

export default Complete;
